import React from 'react';
import cn from 'classnames';
import OnVisible from 'react-on-visible';


import './title.scss';

const Title = ({ label, theme }) => (
	<OnVisible className={`title-label ${cn({ dark: theme === 'dark' })}`}>
		<h1>
			{label}
			<span className="green-point">.</span>
		</h1>
	</OnVisible>
);

const SmallTitle = ({ label, theme }) => (
	<div className={`title-label sm ${cn({ dark: theme === 'dark' })}`}>
		<h6>
			{label}
			<span className="green-point">.</span>
		</h6>
	</div>
);

export { Title, SmallTitle };
